const removeOptionalParamsRegex = /\/[^/\s]*\?/g;
const removeTrailingSlashRegex = /\/$/;
function cleanupPath(path) {
    const result = path
        .replace(removeOptionalParamsRegex, "")
        .replace(removeTrailingSlashRegex, "");
    return result === "" ? "/" : result;
}
function compileRoute(route) {
    const path = route(null);
    const build = function (params) {
        if (!params) {
            return cleanupPath(path);
        }
        const output = Object.keys(params).reduce((acc, k) => acc
            .replace(`/${k}?`, params[k] === true ? `/${k}` : "")
            .replace(`/:${k}?`, params[k] !== undefined ? `/${params[k]}` : "")
            .replace(`/:${k}`, params[k] !== undefined ? `/${params[k]}` : ""), path);
        return cleanupPath(output);
    };
    return Object.create({ path, build: build });
}
export function compileRoutes(routes) {
    return Object.keys(routes).reduce((acc, key) => ({ ...acc, [key]: compileRoute(routes[key]) }), {});
}
//# sourceMappingURL=routes.js.map